/**
 * Like native ES module dynamic import(), but works across origins, and assumes non-module scripts.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement#dynamically_importing_scripts
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
 */
export function importCrossOriginScript(url): Promise<Event> {
  return new Promise((resolve, reject) => {
    const el = document.createElement('script')
    el.src = url
    el.onerror = reject
    el.onload = resolve
    document.head.appendChild(el)
  })
}
